import type { SiteConfig } from '@/types'

/**
 * `url` is the published origin. It is what makes the social preview image,
 * the sitemap and the structured data absolute, so update it here (and in
 * `public/robots.txt` and `public/sitemap.xml`) if the site moves to a
 * custom domain.
 */
export const siteConfig: SiteConfig = {
    name: "Bodin's Resort",
    description: 'Lakeside cabins on the south shore of Lake Superior, between Washburn and Bayfield, Wisconsin. A family vacation destination since 1938, open all year.',
    placeholder: '',
    url: 'https://bodinsresort.modulify.website',
    ogImage: '/images/bodins-boathouse-autumn.jpg'
}

export const contactDetails = {
    addressLines: ['78800 Bodin Rd,', 'Washburn, WI 54891'],
    mailingLines: ['PO Box 687', 'Bayfield, WI 54814'],
    phone: '715-209-7821',
    phoneHref: 'tel:+17152097821',
    email: 'bodinsresort@gmail.com',
    emailHref: 'mailto:bodinsresort@gmail.com',
    established: 'Since 1938',
    availabilityUrl: 'https://via.eviivo.com/BodinsResort54891'
}

export const socialLinks = [
    { label: 'Facebook', handle: 'facebook.com/bodinsresort', href: 'https://www.facebook.com/bodinsresort' },
    { label: 'Instagram', handle: '@bodinsresort', href: 'https://www.instagram.com/bodinsresort' }
]

export const primaryNav = [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about' },
    { label: 'Amenities', href: '/services' },
    { label: 'Packages', href: '/packages' },
    { label: 'Gallery', href: '/gallery' },
    { label: 'News', href: '/news' },
    { label: 'Contact', href: '/contact' }
]

export const sitemapLinks = [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about' },
    { label: 'Amenities', href: '/services' },
    { label: 'Packages', href: '/packages' },
    { label: 'Gallery', href: '/gallery' },
    { label: 'News', href: '/news' },
    { label: 'Contact', href: '/contact' }
]

export const experienceLinks = [
    { label: 'Cabins', href: '/#rooms' },
    { label: 'On the water', href: '/services#water' },
    { label: 'Under the pines', href: '/services#grounds' }
]
